import { FC } from 'react'
import { motion } from 'framer-motion'

const About: FC = () => {
  return (
    <section id="about" className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Text Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.6 }}
          >
            <span className="section-tag">About Us</span>
            <h2 className="section-heading">
              Welcome to Studio Figura Larnaca
            </h2>
            
            <div className="space-y-6 text-text-gray">
              <p className="text-base sm:text-lg">
                We are dedicated to helping you look and feel your best with personalized body-contouring and wellness treatments. Located in the heart of Larnaca, our studio blends advanced technology with expert care to support your journey toward confidence, balance, and wellbeing.
              </p>
              
              <p className="text-base sm:text-lg">
                Our founder, <strong className="text-text-dark">Angela</strong>, brings years of professional experience in aesthetic body treatments. We specialize in tailored solutions, from cellulite reduction to contour shaping, ensuring every client feels supported and empowered.
              </p>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="relative"
          >
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="/assets/jedno_miejsce.webp"
                alt="Studio Figura Interior"
                className="w-full h-auto object-cover"
              />
              {/* Decorative element */}
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-primary/10 rounded-full -z-10" />
              <div className="absolute -top-6 -left-6 w-24 h-24 bg-primary/5 rounded-full -z-10" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default About
